// PT (pt-BR)
export const propCreateHc = {
  firstCreate: {
    // Tipos de acomodação
    typeApartmentLabel: `Apartamento`,
    typeApartmentDesc: `Acomodação mobiliada e independente alugada por inteiro.`,
    typeVillaLabel: `Vila ou casa`,
    typeVillaDesc: `Casas, vilas e chalés alugados por completo.`,
    typeHotelLabel: `Hotel, hostel ou B&B`,
    typeHotelDesc: `Acomodações que gerenciam vários quartos.`,
    typeCampingLabel: `Camping`,
    typeCampingDesc: `Campings e lotes com várias vagas ou unidades.`,

    // Substantivos de estabelecimento / unidade
    venueHotel: `hotel`,
    venueCamping: `camping`,
    roomHotel: `quarto`,
    roomCamping: `lote`,
    roomHotelPlural: `quartos`,
    roomCampingPlural: `lotes`,
    yourVenue: `seu {venue}`,

    // Botões comuns
    back: `Voltar`,
    continue: `Continuar`,

    // Etapa: tipo
    typeTitle: `Vamos cadastrar sua acomodação!`,
    typeSubtitle: `Para começar, escolha o tipo de acomodação que quer publicar.`,

    // Etapa: quantidade
    quantityTitle: `Quantas acomodações você quer cadastrar?`,
    quantitySubtitle: `Você pode começar com uma ou criar várias de uma vez.`,
    oneTitle: `1 acomodação`,
    oneDesc: `Só quero publicar uma por enquanto.`,
    manyTitle: `Mais de 1 acomodação`,
    manyDesc: `Tenho várias para cadastrar.`,

    // Etapa: localização (mesmo edifício ou não)
    locationTitle: `Elas estão no mesmo edifício ou endereço?`,
    locationSubtitle: `Isso nos ajuda a organizar suas acomodações da melhor forma.`,
    sameBuildingYesTitle: `Sim, no mesmo edifício ou endereço`,
    sameBuildingYesDesc: `Serão agrupadas em um único anúncio com várias unidades.`,
    sameBuildingNoTitle: `Não, em endereços diferentes`,
    sameBuildingNoDesc: `Cada uma será um anúncio independente (você configura depois).`,

    // Etapa: nomes (títulos e subtítulos dinâmicos)
    namesTitleAttach: `Adicione uma unidade ao seu anúncio`,
    namesTitleHotel: `Como se chama o seu {venue}?`,
    namesTitleGrouped: `Dê um nome a cada unidade`,
    namesTitleList: `Dê um nome a cada acomodação`,
    namesTitleDefault: `Como se chama a sua acomodação?`,
    namesSubAttach: `Será adicionada como uma nova unidade dentro de “{name}”.`,
    yourListing: `seu anúncio`,
    namesSubHotel: `É o nome que seus hóspedes verão. Na próxima etapa você adiciona os tipos de {room}.`,
    namesSubGrouped: `Cada unidade terá seu próprio calendário dentro do mesmo anúncio.`,
    namesSubList: `Cada uma será um anúncio independente com sua própria configuração.`,
    namesSubDefault: `É o nome que seus hóspedes verão. Você pode alterá-lo quando quiser.`,
    addUnitLabel: `Adicionar outra unidade`,
    addListingLabel: `Adicionar outra acomodação`,

    // Card do anúncio principal (agrupado)
    mainListingEyebrow: `Anúncio principal`,
    mainListingSub: `Agrupa todas as unidades deste edifício em um só anúncio.`,
    mainListingNameLabel: `Nome da acomodação principal`,
    mainListingNamePlaceholder: `Ex: Residencial Bilbao`,
    mainListingNameHint: `Edifício, torre ou local que agrupa as unidades.`,
    currency: `Moeda`,
    currencyHintUnit: `Tarifa por noite de cada unidade.`,

    // Cards de unidade
    unitNameLabel: `Nome da unidade`,
    listingNameLabel: `Nome da acomodação`,
    phRoomCamping: `Ex: Camping Pinar del Mar`,
    phRoomHotel: `Ex: Hotel Costa Azul`,
    phAttach: `Ex: Estúdio de luxo na Playa Roca, na orla`,
    phGrouped: `Ex: Apartamento {n}A`,
    phList: `Acomodação {n}`,
    phDefault: `Ex: Apartamento Centro`,
    remove: `Remover`,
    internalNameOptional: `Nome interno (opcional)`,
    pricePerNight: `Preço / noite`,
    currencyHintHotel: `Todos os {rooms} usam esta moeda.`,

    // Nome interno (caso de nome único)
    internalNameLabel: `Nome interno`,
    optional: `(opcional)`,
    internalNamePlaceholderSingle: `Ex: Apto reformado 2024 / chaves na portaria`,
    internalNameHint: `Só você vê, para identificá-lo internamente. Não é mostrado aos hóspedes.`,

    // Etapa: tipos de quarto (hotel/camping)
    roomsTitle: `Quais {rooms} o {venue} tem?`,
    roomsSubtitle: `Adicione cada tipo de {room} com sua quantidade e seu preço por noite. Você poderá editar quando quiser.`,
    roomTypeLabel: `Tipo de {room}`,
    phRoomTypeCamping: `Ex: Lote com energia elétrica`,
    phRoomTypeHotel: `Ex: Quarto duplo deluxe`,
    quantity: `Quantidade`,
    addRoomType: `Adicionar tipo de {room}`,

    // Etapa: endereço
    addressTitle: `Onde fica a sua acomodação?`,
    addressSubtitle: `Comece a digitar e escolha o endereço. Nós o usamos para o mapa e o check-in.`,
    country: `País`,
    countryHint: `Buscaremos endereços apenas dentro deste país.`,
    address: `Endereço`,
    addressPlaceholder: `Rua, número, cidade…`,
    addressPlaceholderNoCountry: `Primeiro escolha o país`,
    city: `Cidade`,
    zipCode: `CEP`,

    // Etapa: tarifa
    priceTitle: `Sua tarifa padrão por noite`,
    priceSubtitle: `É o seu preço base. Depois você poderá ajustá-lo por temporada ou por canal.`,
    priceLabel: `Preço por noite`,
    perNight: `/ noite`,
    priceHint: `Você pode alterá-lo quando quiser pelo painel.`,

    // Botão principal e motivo da criação
    createUnit: `Adicionar unidade`,
    createVenue: `Criar meu {venue}`,
    createListingsPlural: `Criar minha acomodação | Criar minhas {count} acomodações`,
    reasonUnit: `unidade`,
    reasonListing: `anúncio`,

    // Toasts / validação
    toastCompleteToContinue: `Preencha os dados para continuar.`,
    toastCompleteNames: `Preencha o nome de cada acomodação.`,
    toastCompleteLocation: `Preencha a localização.`,
    toastCompleteRooms: `Preencha cada quarto: nome, quantidade e preço por noite.`,
    toastRoomRatePerUnit: `Informe a tarifa por noite de cada unidade.`,
    toastCompleteRate: `Preencha a tarifa por noite.`,
    toastCreatedPlural: `Acomodação criada! | Acomodações criadas!`,
    toastCreateError: `Não conseguimos criar a acomodação. Tente novamente.`,
  },

  welcome: {
    // Títulos do cabeçalho
    arrivalTitleCaps: `Instruções de Chegada`,
    arrivalTitle: `Instruções de chegada`,
    arrivalSubtitle: `Mensagem que o hóspede recebe no dia da chegada.`,
    welcomeTitle: `Mensagem de boas-vindas`,
    welcomeSubtitle: `Mensagem que o hóspede recebe após concluir o registro.`,
    loadingMessages: `Carregando mensagens...`,

    // Boas-vindas por quarto
    roomWelcomeTitle: `Mensagem de boas-vindas deste quarto`,
    roomWelcomeSub: `Se deixar em branco, a mensagem de boas-vindas geral do hotel é enviada. O interruptor, os anexos e a OTA são configurados no nível do hotel.`,

    // Interruptor de boas-vindas
    welcomeEnableTitle: `Enviar mensagem de boas-vindas`,
    welcomeEnableSub: `O hóspede a recebe após concluir o registro. Se desligar, ela não será enviada.`,

    // Clonar
    clone: `Clonar`,
    clonePullTitle: `Trazer configuração de outra acomodação`,
    clonePullSub: `Importe as boas-vindas de outra para esta`,
    clonePushTitle: `Copiar esta configuração para outra acomodação`,
    clonePushSub: `Aplique estas boas-vindas a outras`,
    cloneModalPullTitle: `Trazer configuração de boas-vindas`,
    cloneModalPushTitle: `Copiar mensagem de boas-vindas`,
    cloneModalPullSubtitle: `Escolha a acomodação de onde quer trazer a configuração. Será aplicada a este anúncio.`,
    cloneModalPushSubtitle: `Copie esta configuração (textos, modo, OTA e anexos) para as acomodações que escolher.`,
    itemNounWelcome: `a mensagem de boas-vindas`,
    arrivalTitleNoun: `instruções de chegada`,
    itemNounArrival: `as instruções de chegada`,

    // Modo de configuração
    modeConfigLabel: `Modo de configuração`,
    modeSingleTitle: `Mensagem única`,
    modeSingleDesc: `Todas as unidades compartilham a mesma mensagem`,
    modeActive: `Ativo`,
    modePropertyTitle: `Por propriedade`,
    modePropertyDesc: `Cada unidade tem sua própria mensagem`,
    modePropertyNotice: `Modo individual ativo. Edite a mensagem em cada propriedade.`,

    // Interruptor de chegada
    arrivalEnableTitle: `Enviar instruções de chegada`,
    arrivalAutoSend: `São enviadas automaticamente no dia da chegada{atTime}.`,
    arrivalAtTime: ` às {time}`,

    // Canais / envio
    deliveryChannels: `Canais de envio`,
    channelEmail: `E-mail`,
    sendAlsoOta: `Enviar também por OTA`,
    sendTime: `Horário de envio`,

    // Editor
    editorSubtitle: `Configure por idioma. Dica: use emojis e texto curto.`,
    translateTitle: `Traduzir de {lang} para os demais idiomas`,
    translatingLangLabel: `Traduzindo {lang}…`,
    translatingGeneric: `Traduzindo…`,
    translate: `Traduzir`,

    // Anexos
    uploading: `Enviando…`,
    attach: `Anexar`,
    emojis: `Emojis`,
    variables: `Variáveis`,
    variablesHint: `Clique para inseri-las. São substituídas pelos dados reais da reserva ao enviar.`,
    uploadDone: `Enviado. Salvando no servidor…`,
    uploadSizeProgress: `{done} de {total} MB`,
    attachHint: `Imagens e PDF até {fileMb} MB · Vídeos em MP4 até {videoMb} MB.`,
    whatsappLimits: `São os limites que o WhatsApp permite.`,
    openFile: `Abrir {name}`,
    attachmentFallback: `anexo`,
    delete: `Excluir`,
    open: `Abrir`,
    arrivalAttachments: `Anexos das instruções de chegada`,
    welcomeAttachments: `Anexos da mensagem de boas-vindas`,
    attachHintFull: `Imagens e PDF até {fileMb} MB · vídeos em MP4 até {videoMb} MB. São os limites que o WhatsApp permite.`,
    noAttachments: `Ainda não há anexos.`,
    editorSubtitleProperty: `Configure por idioma e anexe arquivos (imagens, PDF, vídeo).`,

    // Salvar
    saveData: `Salvar dados`,
    saving: `Salvando…`,

    // Resumo das fechaduras
    locksConfigured: `Fechaduras configuradas`,
    accessMethodConfigured: `Método de acesso configurado`,
    guestAccess: `Acesso do hóspede`,
    accessDisabledHtml: `O envio de códigos de acesso está <strong>desativado</strong>, não será incluído nas instruções de chegada.`,
    noAccessMethod: `Ainda não há nenhum método de acesso configurado nesta acomodação.`,
    locksHint: `É configurado no cartão «Fechaduras e acesso» do anúncio.`,

    // Pré-visualização
    online: `on-line`,
    previewDayArrival: `Dia da chegada`,
    previewAfterRegister: `Após o registro`,
    previewPlaceholder: `Escreva a mensagem para ver a pré-visualização aqui…`,
    previewIncludesAccess: `Inclui o acesso configurado`,
    languageLabel: `idioma {lang}`,
    previewFallbackName: `Sua acomodação`,
    previewFallbackAccommodation: `sua acomodação`,

    // Resumos de fechadura (computed)
    lockNoteDynamic: `Uma nova chave é gerada automaticamente a cada reserva`,
    lockTagBox: `Código do cofre de chaves`,
    lockTag: `Código`,
    lockCodePending: `Código pendente de configuração`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `Entrada`,

    // Mensagens de acesso da pré-visualização (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nSeu código de acesso é: *58117*\n\nVálido durante a sua estadia.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nO cofre de chaves abre com o código: *{code}*\n\nDentro você encontrará as chaves da acomodação. Por favor, deixe-as de volta ao sair.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nO código da fechadura é: *{code}*\n\nUse-o para abrir a porta da acomodação.`,

    // Rótulos das variáveis (computed)
    varGuestName: `Nome do hóspede`,
    varFullName: `Nome completo`,
    varCheckinDate: `Data de entrada`,
    varCheckoutDate: `Data de saída`,
    varCheckinTime: `Horário de check-in`,
    varCheckoutTime: `Horário de check-out`,
    varNights: `Número de noites`,
    varGuests: `Número de hóspedes`,

    // Opções de fechadura (computed)
    lockOptBoxTitle: `Cofre de chaves`,
    lockOptBoxDesc: `As chaves estão em um cofre de chaves de segurança.`,
    lockOptDynamicTitle: `Fechadura inteligente`,
    lockOptDynamicDesc: `Cada reserva cria uma nova chave automaticamente.`,
    lockOptStaticTitle: `Fechadura com código fixo`,
    lockOptStaticDesc: `Um cofre de chaves ou uma fechadura com código fixo.`,

    // Mensagem de chegada padrão (computed)
    defaultArrivalMessage: `🏡 *Instruções de chegada*\n\nOlá *{guest}* 👋\n\nAo chegar, dirija-se à entrada principal da acomodação. 🔑\n\nSe precisar de ajuda, escreva para nós por este mesmo WhatsApp 📲\n\nBoa estadia! ✨`,

    // Contexto da propriedade (herdado)
    inheritedChannelsTitle: `Canais herdados do listing`,
    inheritedListingPrefix: `Esta propriedade usa o welcome centralizado do listing`,
    emailChannel: `Correio eletrônico`,
    otaActive: `OTA ativa`,
    inheritedNote: `Se quiser alterar o envio por OTA deste welcome, faça-o nas configurações do anúncio/listing.`,
    propertyDeliveryTitle: `Por onde este welcome será enviado?`,
    propertyDeliverySubtitle: `Configure os canais de envio para esta propriedade.`,
    propertyDeliveryNote: `Esses canais continuam ativos por padrão. Aqui você também pode adicionar o envio por OTA para esta propriedade.`,
    otaRowTitle: `Enviar mensagens de boas-vindas por OTAs`,
    otaRowText: `Tentará enviar o welcome desta propriedade pela Booking.com e Airbnb usando o Channex, com seus anexos configurados.`,
    otaRowHint: `É salvo junto com a mensagem e os anexos de boas-vindas.`,

    // Toasts / validação
    toastLoadError: `Não foi possível carregar as mensagens.`,
    toastOtaUpdated: `Canal OTA atualizado com sucesso`,
    toastOtaError: `Não foi possível atualizar o envio por OTA`,
    toastSendTimeUpdated: `Horário de envio atualizado`,
    toastSendTimeError: `Não foi possível salvar o horário`,
    toastArrivalEnabled: `Instruções de chegada ativadas`,
    toastArrivalDisabled: `Instruções de chegada desativadas`,
    toastStatusError: `Não foi possível atualizar o status`,
    toastWelcomeEnabled: `Mensagem de boas-vindas ativada`,
    toastWelcomeDisabled: `Mensagem de boas-vindas desativada`,
    toastModeUpdated: `Modo atualizado com sucesso`,
    toastModeError: `Não foi possível atualizar o modo`,
    toastAttachUploaded: `Anexo(s) enviado(s) com sucesso`,
    toastAttachUploadError: `Erro ao enviar anexos`,
    toastAttachDeleted: `Anexo excluído`,
    toastAttachDeleteError: `Não foi possível excluir o anexo`,
    toastChangesSaved: `Alterações salvas`,
    toastTranslateEmpty: `Escreva uma mensagem no idioma ativo antes de traduzir.`,
    toastTranslateSuccess: `{count} idiomas traduzidos! Revise cada aba antes de salvar.`,
    toastTranslatePartial: `{success} traduzidos, {failed} falharam. Você pode tentar novamente.`,
    toastTranslateNone: `Não foi possível traduzir nenhum idioma. Tente novamente.`,

    // Erros de validação de arquivos (WhatsApp)
    fileErrorVideoFormat: `❌ {name} é um vídeo {ext} e o WhatsApp só aceita MP4. Converta-o para MP4 e envie novamente.`,
    fileErrorTooBig: `❌ {name} tem {mb} MB e o máximo são {limMb} MB. `,
    fileErrorTooBigVideo: `O WhatsApp não aceita vídeos maiores: comprima-o ou recorte-o.`,
    fileErrorTooBigFile: `O WhatsApp não aceita arquivos maiores.`,
  },
};
